import { DrawerCloseButton as ChakraDrawerCloseButton } from '@chakra-ui/react'

import { DrawerCloseButtonProps } from './DrawerCloseButton.types'

export default function Drawer(props: DrawerCloseButtonProps) {
  return <ChakraDrawerCloseButton {...props} translate="no" />
}
